import React, { CSSProperties, FC } from 'react';

import aampeTheme from '../../constants/aampeTheme';

import { CompactTabItem } from '../nav/CompactTabMenu/CompactTab';
import CompactTabMenu from '../nav/CompactTabMenu/CompactTabMenu';

interface SubMenuTabBarProps {
    tabs: CompactTabItem[];
    currentTab: string;
    setCurrentTab: (value: string) => void;
    labelsCountMap?: Record<string, number>;
    customStyle?: CSSProperties;
}

const tabStyling = (
    isActive: boolean,
    tabsCount: number,
    breakpoint: string | undefined,
) => ({
    color: isActive ? aampeTheme.colors.solidA01 : aampeTheme.colors.neutral09,
    backgroundColor: aampeTheme.colors.white,
    fontWeight: isActive ? aampeTheme.weights.medium : aampeTheme.weights.light,
    textDecoration: isActive
        ? `underline ${aampeTheme.colors.orange400}`
        : undefined,
    textUnderlineOffset: isActive ? aampeTheme.spacing(1.7) : 'none',
    textDecorationThickness: '3px',
    lineHeight: aampeTheme.spacing(3),
    height: aampeTheme.spacing(3),
    marginRight: aampeTheme.spacing(1),
    fontSize:
        breakpoint && ['sm', 'md', 'ml', 'lg'].includes(breakpoint)
            ? aampeTheme.size.font.textSmall
            : aampeTheme.size.font.default,
    paddingLeft: 0,
});

const tabMenuStyling = {
    padding: aampeTheme.spacing4(4, 2, 2, 0),
    borderBottom: `1px solid ${aampeTheme.colors.interactiveWG01}`,
    marginBottom: 0,
    background: aampeTheme.colors.white,
    margin: aampeTheme.spacing(0),
};

const SubMenuTabBar: FC<SubMenuTabBarProps> = ({
    tabs,
    currentTab,
    setCurrentTab,
    customStyle,
}) => {
    return (
        <CompactTabMenu
            activeTabKey={currentTab as string}
            onTabClick={setCurrentTab as any}
            tabs={tabs}
            tabStyling={tabStyling}
            tabMenuStyling={{ ...tabMenuStyling, ...(customStyle || {}) }}
        />
    );
};

export default SubMenuTabBar;
